module.exports = require('../dist/components/Button/Button');
